import { render, staticRenderFns } from "./UnappliedStartupsModal.vue?vue&type=template&id=a1e6007a&scoped=true&"
import script from "./UnappliedStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UnappliedStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e6007a",
  null
  
)

export default component.exports